import posthog from "posthog-js";
import type { PostHogEventName } from "./posthog-events";

const toSnakeCase = (str: string): string =>
    str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

const normalizeProperties = (properties: Record<string, unknown>): Record<string, unknown> =>
    Object.fromEntries(Object.entries(properties).map(([k, v]) => [toSnakeCase(k), v]));

/**
 * Capture a PostHog event. Only events declared in PostHogEvents are allowed (enforced by type).
 * When PostHog is initialized (prod only), events are sent; otherwise they are logged to the console.
 * Property keys are normalized from camelCase to snake_case automatically.
 */
export function capturePosthogEvent(
    event: PostHogEventName,
    properties?: Record<string, unknown>
): void {
    const normalized = properties ? normalizeProperties(properties) : undefined;
    if (posthog.__loaded) {
        posthog.capture(event, normalized);
    } else {
        console.log(`[PostHog]`, event, normalized ?? {});
    }
}
